import React, { useContext, useMemo } from 'react';
import { Avatar, Box } from '@mui/material';
import { ChatbotWidgetContext } from 'components/ChatbotWidget/utils/ChatbotWidgetContext';
import styles from './TypingIndicator.module.scss';
import classNames from 'classnames/bind';
import { Card } from 'gd-design-library';

const cx = classNames.bind(styles);

const CN = 'typing-indicator';
const cardClass = `${CN}__card`;
const dotClass = `${CN}__dot`;

interface TypingIndicatorProps {
  whoIsTyping: {
    userType: string;
    id: number;
  } | null;
}

export const TypingIndicator = ({ whoIsTyping }: TypingIndicatorProps): React.ReactElement => {
  const { client } = useContext(ChatbotWidgetContext);

  const agentAvatarUrl = useMemo(() => {
    if (!client || !whoIsTyping) return;

    switch (whoIsTyping.userType) {
    case 'virtual_agent':
      return client.chat?.state.all_virtual_agents.find(agent => agent.id === whoIsTyping.id)?.avatar_url;
    case 'user':
      return client.chat?.state.all_agents.find(agent => agent.id === whoIsTyping.id)?.avatar_url;
    default:
      return null;
    }
  }, [ client, whoIsTyping ]);

  return whoIsTyping !== null && (
    <Box className={ cx(CN) }>
      <Avatar src={ agentAvatarUrl } />
      <Card variant='horizontal' className={ cx(cardClass) }>
        <div className={ cx(dotClass) } style={ { animationDelay: '0s' } } />
        <div className={ cx(dotClass) } style={ { animationDelay: '0.1s' } } />
        <div className={ cx(dotClass) } style={ { animationDelay: '0.2s' } } />
      </Card>
    </Box>
  );
};
